import SectionHeading from "@/components/feature/SectionHeading";
import FeatureGrid from "@/components/feature/FeatureGrid";
import { solucoesOverview, overviewCards } from "@/mocks/solucoes";

export default function SolucoesIntro() {
  return (
    <section className="bg-background-50 py-16 md:py-24">
      <div className="mx-auto max-w-7xl px-4 md:px-8">
        <SectionHeading
          badge={solucoesOverview.badge}
          badgeIcon="ri-apps-2-line"
          title={solucoesOverview.title}
          description={solucoesOverview.description}
        />
        <div className="mt-12">
          <FeatureGrid items={overviewCards} columns={4} accent="primary" />
        </div>
      </div>
    </section>
  );
}